



























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { InputText, InputNumber } from "@/components/exchange/input";
import { mapGetters } from "vuex";
import { ISortParameters } from "@/interfaces";
import { AppsMonitorHeader } from "@/components/apps";
import { AppsService, AccountService } from "../services";
import { knownAppsList } from "@/config";
import axios from "axios";
import TronWeb from "tronweb";
import walletvalidator from "wallet-address-validator";
const HttpProvider = TronWeb.providers.HttpProvider;
const fullNode = new HttpProvider("https://api.trongrid.io");
const solidityNode = new HttpProvider("https://api.trongrid.io");
const tronWeb = new TronWeb(fullNode, solidityNode);
@Component({
  components: {
    AppsMonitorHeader,
    InputText,
    InputNumber,
  },
  mounted() {
    const self = this;
    let params = {
      currency: self.$data.currency,
      amount: self.$data.amount,
    };
    axios
      .get("https://rfdax.herokuapp.com/price", {
        params,
      })
      .then(function(result) {
        self.$data.price = result.data.price;
        self.$data.fee = result.data.fee;
        self.$data.fixedfees = result.data.fixedfees;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  computed: {
    ...mapGetters("network", ["height", "allApps", "topApps", "knownApps"]),
    total() {
      const self = this;
      return self.$data.amount * self.$data.price - self.$data.fee - self.$data.fixedfees;
    },
    totalbefore() {
      return this.$data.amount * this.$data.price;
    },
  },
  data: () => ({
    receiver: "rfdax",
    amount: 20,
    address: null,
    currency: "USDT",
    order: null,
    estimation: null,
    tag: null,
    price: null,
    fee: null,
    fixedfees: 1,
    error: null,
  }),
  methods: {
    estimate: function(currency) {
      const self = this;
      self.$data.currency = currency;
      let params = {
        currency: self.$data.currency,
        amount: self.$data.amount,
        refferer:"steemscan"
      };
      axios
        .get("https://rfdax.herokuapp.com/price", {
          params,
        })
        .then(function(result) {
          self.$data.price = result.data.price;
          self.$data.fee = result.data.fee;
          self.$data.fixedfees = result.data.fixedfees;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    createOrder: function() {
      const self = this;
      let params = {
        address: self.$data.address,
        currency: self.$data.currency,
        amount: self.$data.amount,
        refferer:"steemscan"
      };
      self.$data.error = "";
      if (self.$data.currency === "TRX") {
        tronWeb.trx.getAccount(self.$data.address, (error, userBalance) => {
          if (!error) {
            axios
              .get("https://rfdax.herokuapp.com/create_order", {
                params,
              })
              .then(function(result) {
                console.log(result);
                if (!result.data.error) self.$data.order = result.data;
                else self.$data.error = result.data.error;
              })
              .catch(function(err) {
                console.log(err.response.data);
              });
          } else {
            self.$data.error = "This is not a valid TRX address";
          }
        });
      } else {
        let currency = self.$data.currency;
        if (currency === "USDT") currency = "ETH";
        let valid = walletvalidator.validate(self.$data.address, currency);
        if (valid)
          axios
            .get("https://rfdax.herokuapp.com/create_order", {
              params,
            })
            .then(function(result) {
              console.log(result);
              if (!result.data.error) self.$data.order = result.data;
              else self.$data.error = result.data.error;
            })
            .catch(function(err) {
              console.log(err.response.data);
            });
        else self.$data.error = `This is not a valid ${currency} address`;
      }
    },
    processPayment: function() {
      const url = `https://steemlogin.com/sign/transfer?from=&to=${this.$data.receiver}&amount=${this.$data.order.amount} STEEM&memo=${this.$data.order.memo}`;
      const win = window.open(
        url.split("+").join("_"),
        "_blank",
        "toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=500,width=600,height=600",
      );
    },
  },
})
export default class AppsMonitor extends Vue {
  private activeTab = "top";
  private height: number;

  get currencies() {
    return ["USDT", "BTC", "TRX"];
  }

  get selectOptions() {
    return this.currencies;
  }

  private onInputChange(event: any) {
    const { name, value } = event.target;
    this.$data[name] = value;
  }
}
